import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import PieChart from '../PieChart';
import useStyles from './styles';
import chartTranslations from '../translations';

const GenderPieEchart = ({
  title, unitName, data,
}) => {
  const { t } = useTranslation(['translation'])
  // The magic of echart is that this order will be inverted :-)
  const maleFirstData = data[0].name === 'male' ? data : [data[1], data[0]];
  const total = data[0].value + data[1].value;
  const malePercentage = Math.round(100 * maleFirstData[0].value / total);
  const femalePercentage = Math.round(100 * maleFirstData[1].value / total);
  const malePercentageText = Number.isNaN(malePercentage) ? '-%' : `${malePercentage}%`;
  const femalePercentageText = Number.isNaN(femalePercentage) ? '-%' : `${femalePercentage}%`;

  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <p className={classes.title}>{title}</p>
        <div className={classes.legendContainer}>
          <p className={classes.femaleText}>{t('ANALYTICS.CHARTS.FEMALE')}</p>
          <p className={classes.maleText}>{t('ANALYTICS.CHARTS.MALE')}</p>
        </div>
      </div>
      <div className={classes.chartContainer}>
        <PieChart
          data={maleFirstData.map(x => ({ ...x, name: t(chartTranslations(x.name)) }))}
          unitName={unitName}
          backgroundColor="transparent"
          bigPie
          hideLegend
        />
      </div>
      <div className={classes.footerContainer}>
        <div className={classes.footerTextContainer}>
          <p className={classes.footerText}>{t('ANALYTICS.CHARTS.FEMALE')}</p>
          <p className={classes.footerPercent}>{femalePercentageText}</p>
        </div>
        <div className={classes.footerTextContainer}>
          <p className={classes.footerText}>{t('ANALYTICS.CHARTS.MALE')}</p>
          <p className={classes.footerPercent}>{malePercentageText}</p>
        </div>
      </div>
    </div>
  );
};

GenderPieEchart.propTypes = {
  title: PropTypes.string.isRequired,
  unitName: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.number,
  })).isRequired,
};

export default GenderPieEchart;
